import { clamp, random, smooth } from "../mineral-processing/motion";

export { clamp, random, smooth };
export const TRANSPORT_CHAPTERS = [0, .19, .46, .82] as const;
export const TRUCK_HINGE = [0, 2.23, -2.30] as const;
export const TRANSPORT_ROCK_COUNT = 84;
export const floorHeight = (z: number) => 2.830 - .156 * z;
export const bedAngle = (progress: number) => .79 * smooth((progress - .46) / .19) * (1 - smooth((progress - .84) / .11));
export const transportChapter = (progress: number) => progress < .19 ? 0 : progress < .46 ? 1 : progress < .82 ? 2 : 3;

/** Shared bulk surface keeps visible stones and fine grains seated in the load. */
export function soilLoadRelief(x: number, z: number, radial: number) {
  const cap = Math.pow(Math.max(0, 1 - radial * radial), .80);
  return cap * (1 + .14 * Math.sin(x * 2.3 + z * 1.8) + .09 * Math.sin(x * 5.1 - z * 3.3)
    + .020 * Math.sin(x * 37 + z * 21) * Math.sin(z * 29 - x * 13));
}
export const loadRemaining = (p: number) => 1 - smooth((p - .60) / .11);

export function transportRockSpec(index: number) {
  const incoming = index >= 72, n = incoming ? index - 72 : index;
  const layer = incoming ? 0 : Math.floor(index / 24);
  const radial = Math.sqrt((n + .5) / 72) * .92, angle = n * 2.399963 + random(index + 18) * .25;
  const x = incoming ? (n % 4 - 1.5) * .84 : Math.cos(angle) * radial * 1.57;
  const z = incoming ? -1.65 + Math.floor(n / 4) * .60 : .15 + Math.sin(angle) * radial * 1.90;
  return { x, z, radial,
    radius: incoming ? .20 + random(index + 210) * .065 : .08 + Math.pow(random(index + 220), 1.7) * .22,
    layer, incoming, release: .205 + random(index + 410) * .115 };
}

/** Authored loading/unloading path, reversible under scroll; not a payload or wear calculation. */
export function transportRockState(index: number, progress: number) {
  const spec = transportRockSpec(index);
  const start = .525 + random(index + 313) * .035, time = Math.max(0, (progress - start) * 12);
  const travel = 1.6 * time * time, exitTime = Math.sqrt((spec.z + 2.60) / 1.6);
  const exitProgress = start + exitTime / 12;
  const fall = clamp((progress - spec.release) / .072);
  const bounce = fall >= 1 ? .09 * Math.abs(Math.sin((progress - spec.release - .072) * 170)) * (1 - smooth((progress - spec.release - .072) / .04)) : 0;
  const z = spec.z - travel;
  return { ...spec, visible: !spec.incoming || progress >= spec.release, x: spec.x,
    y: floorHeight(z) + spec.radius * .72 + (!spec.incoming ? soilLoadRelief(spec.x, z, spec.radial) * loadRemaining(progress) : 3.1 * (1 - fall * fall) + bounce),
    z, travel, exited: progress > exitProgress, afterExit: Math.max(0, (progress - exitProgress) * 12),
    exitSpeed: 3.2 * exitTime, exitAngle: bedAngle(exitProgress), exitY: floorHeight(-2.60) + spec.radius * .72
      + (!spec.incoming ? soilLoadRelief(spec.x, -2.60, spec.radial) * loadRemaining(exitProgress) : 0) };
}
